export enum PlanetType {
    Terrestrial,
    SuperEarth,
    Jovian,
    Neptunian,
    Unknown
}

export interface ExoplanetSummaryData {
    planetType: PlanetType,
    orbitalDistance_au: number,
    mass_jupiterMasses_log: number
    radius_jupiterRadii_log: number
}